import React from 'react'
import PropTypes from 'prop-types'

import { find, get, mapKeys } from 'lodash'
import { CountrySelector, Input, StateSelector } from 'components/forms'
import { notEmail, required } from 'lib/form-validation'
import { Col, Row } from 'react-bootstrap'
import { getCityStateByZip } from 'registry/api'

export function createValidationRules(context) {
  let fields = {
    city: [required],
    country: [required],
    name: [required, notEmail],
    streetAddress1: [required, notEmail],
    zip: [required],
    state: [
      (state, data) => {
        if (get(data, context ? `${context}.country` : 'country'))
          return required(state, data)
      },
    ],
  }

  // Context is used to determine the full path of the key in the state
  if (context) {
    fields = mapKeys(fields, (value, key) => {
      return `${context}.${key}`
    })
  }
  return fields
}

class ShippingFields extends React.Component {
  static propTypes = {
    city: PropTypes.object,
    countries: PropTypes.arrayOf(PropTypes.string),
    country: PropTypes.object,
    excludedFields: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.object,
    phone: PropTypes.object,
    states: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
    state: PropTypes.object,
    streetAddress1: PropTypes.object,
    streetAddress2: PropTypes.object,
    zip: PropTypes.object,
  }

  render() {
    const {
      city,
      excludedFields = [],
      countries,
      country,
      name: fullName,
      phone,
      states,
      state,
      streetAddress1,
      streetAddress2,
      zip,
    } = this.props

    return (
      <div>
        {!excludedFields.includes('name') && (
          <Input
            {...fullName}
            label="Full Name"
            type="text"
            error={fullName.touched ? fullName.error : null}
          />
        )}

        <Row>
          <Col xs={12} sm={9}>
            {!excludedFields.includes('streetAddress1') && (
              <Input
                {...streetAddress1}
                label="Street Address"
                type="text"
                error={streetAddress1.touched ? streetAddress1.error : null}
              />
            )}
          </Col>

          <Col xs={12} sm={3}>
            {!excludedFields.includes('streetAddress2') && (
              <Input {...streetAddress2} label="Apt/Suite" type="text" />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={3} sm={3}>
            {!excludedFields.includes('zip') && (
              <Input
                {...zip}
                label={country.value == 'United States' ? 'Zip' : 'Postal Code'}
                type="text"
                onChange={this.handleZipChange}
                error={zip.touched ? zip.error : null}
              />
            )}
          </Col>

          <Col xs={6}>
            {!excludedFields.includes('city') && (
              <Input
                {...city}
                label="City"
                type="text"
                error={city.touched ? city.error : null}
              />
            )}
          </Col>

          <Col xs={3} sm={3}>
            {!excludedFields.includes('state') && (
              <StateSelector
                {...state}
                states={states}
                country={country.value || countries[0]}
                error={state.touched ? state.error : null}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            {!excludedFields.includes('country') && (
              <CountrySelector
                {...country}
                countries={countries}
                error={country.touched ? country.error : null}
                onChange={this.handleCountryChange.bind(this)}
                value={country.value || countries[0]}
              />
            )}
          </Col>
          <Col xs={6}>
            {!excludedFields.includes('phone') && (
              <Input {...phone} label="Phone" type="text" />
            )}
          </Col>
        </Row>
      </div>
    )
  }

  handleCountryChange(value) {
    const { country, state } = this.props

    // Clear out state if country is changing to or from US or Canada
    if (
      find(
        [country.value, value],
        (country) => country == 'United States' || country == 'Canada'
      )
    ) {
      state.onChange('')
    }
    country.onChange(value)
  }

  handleZipChange = (e) => {
    const { city, state, zip } = this.props

    // Only autofill city and state for correct looking US zip
    let fiveDigitZip = e.target.value.match(/\d{5}/)
    if (fiveDigitZip) {
      getCityStateByZip(fiveDigitZip[0]).then((resp) => {
        resp.city && city.onChange(resp.city)
        resp.state && state.onChange(resp.state)
      })
    }

    zip.onChange(e.target.value)
  }
}

export default ShippingFields
